import { create } from "zustand";

interface AdviceInputState {
  retirementAge: number;
  riskPreference: number;
  updateRetirementAge: (retirementAge: number) => void;
  updateRiskPreference: (riskPreference: number) => void;
}

export const useAdviceInputStore = create<AdviceInputState>((set) => ({
  retirementAge: 68,
  riskPreference: 50,
  updateRetirementAge: (retirementAge: number) =>
    set({ retirementAge: retirementAge }),
  updateRiskPreference: (riskPreference: number) =>
    set({ riskPreference: riskPreference }),
}));
